/* eslint-disable max-lines */
import * as React from "react";

import { values } from "lodash";
import { connect } from "react-redux";

import { mapDispatchToQuestionnaireSectionProps, makeMapStateToQuestionnaireSectionProps } from "@teamprevent/common/questionnaires/mappers";
import { getAnswerToQuestionWithId } from "@teamprevent/common/questionnaires/getAnswerToQuestionWithId";
import { MultiButtonQuestion } from "@teamprevent/common/questionnaires/components/questions/MultiButtonQuestion";

import { ContextAwareProgressBarQuestionnaireSection } from "@teamprevent/common/questionnaires/components/ContextAwareProgressBarQuestionnaireSection";

import { getQuestionConfig } from "@teamprevent/common/questionnaires/questionnaireConfig";

import { HealthSurveillanceSectionProps } from "../models";
import { sections } from "../questionnaire";

import * as questionIds from "../questions/questionIds";

const HealthSurveillanceNightWorkerSectionUnconnected: React.FunctionComponent<HealthSurveillanceSectionProps> = (props: HealthSurveillanceSectionProps) => {
    const showQuestionsIfAnsweredYes = React.useCallback((questionId: string) => {
        return getAnswerToQuestionWithId(values(props.questions || {}), questionId) === MultiButtonQuestion.YesOption;
    }, [props.questions]);

    const anxietyStressOrDepressionQuestions = () =>
        (
            <>
                <MultiButtonQuestion
                    readonly={props.readonly}
                    questionClassName="question-bold"
                    mandatory
                    questionConfig={getQuestionConfig(
                        props.questionConfigs,
                        questionIds.AnxietyStressOrDepression,
                    )}
                />
                {
                    showQuestionsIfAnsweredYes(questionIds.AnxietyStressOrDepression) &&
                    <>
                        <MultiButtonQuestion
                            readonly={props.readonly}
                            mandatory
                            questionConfig={getQuestionConfig(
                                props.questionConfigs,
                                questionIds.AdmittedToHospitalDueToAnxietyStressDepressionInTheLastTwoYears,
                            )}
                        />
                        <MultiButtonQuestion
                            readonly={props.readonly}
                            mandatory
                            questionConfig={getQuestionConfig(
                                props.questionConfigs,
                                questionIds.MoreThanTwoConsecutiveWeeksOffSickDueToAnxietyStressDepressionEmotionalBurnoutInTheLastTwoYears,
                            )}
                        />
                        <MultiButtonQuestion
                            readonly={props.readonly}
                            mandatory
                            questionConfig={getQuestionConfig(
                                props.questionConfigs,
                                questionIds.AreYourAnxietySymptomsWellControlled,
                            )}
                        />
                        <MultiButtonQuestion
                            readonly={props.readonly}
                            mandatory
                            questionConfig={getQuestionConfig(
                                props.questionConfigs,
                                questionIds.ReceivingOrAwaitingTreatmentForAMentalHealthConcernOrCondition,
                            )}
                        />
                    </>
                }
            </>
        );

    const otherMentalHealthProblemsIncludingAnyDrugOrAlcoholProblemsQuestions = () =>
        (
            <>
                <MultiButtonQuestion
                    readonly={props.readonly}
                    questionClassName="question-bold"
                    mandatory
                    questionConfig={getQuestionConfig(
                        props.questionConfigs,
                        questionIds.OtherMentalHealthProblemsIncludingAnyDrugOrAlcoholProblems,
                    )}
                />
                {
                    showQuestionsIfAnsweredYes(questionIds.OtherMentalHealthProblemsIncludingAnyDrugOrAlcoholProblems) &&
                            <>
                                <MultiButtonQuestion
                                    readonly={props.readonly}
                                    mandatory
                                    questionConfig={getQuestionConfig(
                                        props.questionConfigs,
                                        questionIds.HaveYouEverHadADrugOrAlcoholProblem,
                                    )}
                                />
                                <MultiButtonQuestion
                                    readonly={props.readonly}
                                    mandatory
                                    questionConfig={getQuestionConfig(
                                        props.questionConfigs,
                                        questionIds.HaveYouBeenAdmittedToHospitalDueToAMentalHealthProblem,
                                    )}
                                />
                                <MultiButtonQuestion
                                    readonly={props.readonly}
                                    mandatory
                                    questionConfig={getQuestionConfig(
                                        props.questionConfigs,
                                        questionIds.HaveYouEverHadMoreThanTwoConsecutiveWeeksOffSickDueToAMentalHealthProblem,
                                    )}
                                />
                                <MultiButtonQuestion
                                    readonly={props.readonly}
                                    mandatory
                                    questionConfig={getQuestionConfig(
                                        props.questionConfigs,
                                        questionIds.AreYourDrugOrAlcoholSymptomsWellControlled,
                                    )}
                                />
                                <MultiButtonQuestion
                                    readonly={props.readonly}
                                    mandatory
                                    questionConfig={getQuestionConfig(
                                        props.questionConfigs,
                                        questionIds.DoYouHaveAnyCognitiveImpairmentDifficultlyRememberingLearningNewThingsOrBrainFog,
                                    )}
                                />
                                <MultiButtonQuestion
                                    readonly={props.readonly}
                                    mandatory
                                    questionConfig={getQuestionConfig(
                                        props.questionConfigs,
                                        questionIds.HaveYouHadAPsychoticIllness,
                                    )}
                                />
                                <MultiButtonQuestion
                                    readonly={props.readonly}
                                    mandatory
                                    questionConfig={getQuestionConfig(
                                        props.questionConfigs,
                                        questionIds.HaveYouBeenDiagnosedWithAPersonalityDisorder,
                                    )}
                                />
                                <MultiButtonQuestion
                                    readonly={props.readonly}
                                    mandatory
                                    questionConfig={getQuestionConfig(
                                        props.questionConfigs,
                                        questionIds.HaveYouBeenDiagnosedWithAnyOtherMentalHealthCondition,
                                    )}
                                />
                            </>
                }
            </>
        );
    const heartConditionAnginaHighBloodPressureQuestions = () =>
        (
            <>
                {<MultiButtonQuestion
                    readonly={props.readonly}
                    questionClassName="question-bold"
                    mandatory
                    questionConfig={getQuestionConfig(
                        props.questionConfigs,
                        questionIds.HeartConditionAnginaHighBloodPressure,
                    )}
                />}
                {
                    showQuestionsIfAnsweredYes(questionIds.HeartConditionAnginaHighBloodPressure) &&
                            <>
                                <MultiButtonQuestion
                                    readonly={props.readonly}
                                    mandatory
                                    questionConfig={getQuestionConfig(
                                        props.questionConfigs,
                                        questionIds.HaveYouBeenAdmittedToHospitalDueToAHeartConditionInTheLastTwoYears,
                                    )}
                                />
                                <MultiButtonQuestion
                                    readonly={props.readonly}
                                    mandatory
                                    questionConfig={getQuestionConfig(
                                        props.questionConfigs,
                                        questionIds.HaveYouEverHadMoreThanTwoConsecutiveWeeksOffSickDueToAHeartConditionInTheLastTwoYears,
                                    )}
                                />
                                <MultiButtonQuestion
                                    readonly={props.readonly}
                                    mandatory
                                    questionConfig={getQuestionConfig(
                                        props.questionConfigs,
                                        questionIds.AreYourHeartConditionSymptomsWellControlled,
                                    )}
                                />
                                <MultiButtonQuestion
                                    readonly={props.readonly}
                                    mandatory
                                    questionConfig={getQuestionConfig(
                                        props.questionConfigs,
                                        questionIds.DoYouHaveDifficultyWalkingOrClimbingUpStairsDueToAHeartCondition,
                                    )}
                                />
                                <MultiButtonQuestion
                                    readonly={props.readonly}
                                    mandatory
                                    questionConfig={getQuestionConfig(
                                        props.questionConfigs,
                                        questionIds.DoesThisHeartConditionAffectYourMobilityInAnyWay,
                                    )}
                                />
                            </>
                }
            </>
        );
    const asthmaBronchitisChestDiseaseRespiratoryProblemsQuestions = () =>
        (
            <>
                {<MultiButtonQuestion
                    readonly={props.readonly}
                    questionClassName="question-bold"
                    mandatory
                    questionConfig={getQuestionConfig(
                        props.questionConfigs,
                        questionIds.AsthmaBronchitisChestDiseaseRespiratoryProblems,
                    )}
                />}
                {
                    showQuestionsIfAnsweredYes(questionIds.AsthmaBronchitisChestDiseaseRespiratoryProblems) &&
                            <>
                                <MultiButtonQuestion
                                    readonly={props.readonly}
                                    mandatory
                                    questionConfig={getQuestionConfig(
                                        props.questionConfigs,
                                        questionIds.HaveYouBeenAdmittedToHospitalDueToAsthmaProblemsInTheLastTwoYears,
                                    )}
                                />
                                <MultiButtonQuestion
                                    readonly={props.readonly}
                                    mandatory
                                    questionConfig={getQuestionConfig(
                                        props.questionConfigs,
                                        questionIds.HaveYouEverHadMoreThanTwoConsecutiveWeeksOffSickDueToAsthmaProblemsInTheLastTwoYears,
                                    )}
                                />
                                <MultiButtonQuestion
                                    readonly={props.readonly}
                                    mandatory
                                    questionConfig={getQuestionConfig(
                                        props.questionConfigs,
                                        questionIds.AreYourAsthmaSymptomsWellControlled,
                                    )}
                                />
                                <MultiButtonQuestion
                                    readonly={props.readonly}
                                    mandatory
                                    questionConfig={getQuestionConfig(
                                        props.questionConfigs,
                                        questionIds.IfYouSufferFromAsthmaIsThisTriggeredByAnythingThatYouCouldComeInToContactWithAtWork,
                                    )}
                                />
                            </>
                }
            </>
        );
    const fitsBlackoutsFaintsUnexplainedLossOfConsciousnessQuestions = () =>
        (
            <>
                {<MultiButtonQuestion
                    readonly={props.readonly}
                    questionClassName="question-bold"
                    mandatory
                    questionConfig={getQuestionConfig(
                        props.questionConfigs,
                        questionIds.FitsBlackoutsFaintsUnexplainedLossOfConsciousness,
                    )}
                />}
                {
                    showQuestionsIfAnsweredYes(questionIds.FitsBlackoutsFaintsUnexplainedLossOfConsciousness) &&
                            <>
                                <MultiButtonQuestion
                                    readonly={props.readonly}
                                    mandatory
                                    questionConfig={getQuestionConfig(
                                        props.questionConfigs,
                                        questionIds.HaveYouBeenAdmittedToHospitalDueToFitsInTheLastTwoYears,
                                    )}
                                />
                                <MultiButtonQuestion
                                    readonly={props.readonly}
                                    mandatory
                                    questionConfig={getQuestionConfig(
                                        props.questionConfigs,
                                        questionIds.AreYourFitsSymptomsWellControlled,
                                    )}
                                />
                                <MultiButtonQuestion
                                    readonly={props.readonly}
                                    mandatory
                                    questionConfig={getQuestionConfig(
                                        props.questionConfigs,
                                        questionIds.AreYourEpisodesOfFitsTriggeredByAnythingThatYouCouldComeInToContactWithAtWork,
                                    )}
                                />
                                <MultiButtonQuestion
                                    values={["None", "1 or more"]}
                                    readonly={props.readonly}
                                    mandatory
                                    questionConfig={getQuestionConfig(
                                        props.questionConfigs,
                                        questionIds.HowManyEpisodesOfFitsHaveYouExperiencedDuringTheLastYear,
                                    )}
                                />
                            </>
                }
            </>
        );
    const diabetesQuestions = () =>
        (
            <>
                {<MultiButtonQuestion
                    readonly={props.readonly}
                    questionClassName="question-bold"
                    mandatory
                    questionConfig={getQuestionConfig(
                        props.questionConfigs,
                        questionIds.Diabetes,
                    )}
                />}
                {
                    showQuestionsIfAnsweredYes(questionIds.Diabetes) &&
                            <>
                                <MultiButtonQuestion
                                    readonly={props.readonly}
                                    mandatory
                                    questionConfig={getQuestionConfig(
                                        props.questionConfigs,
                                        questionIds.HaveYouBeenAdmittedToHospitalDueToDiabetesInTheLastTwoYears,
                                    )}
                                />
                                <MultiButtonQuestion
                                    readonly={props.readonly}
                                    mandatory
                                    questionConfig={getQuestionConfig(
                                        props.questionConfigs,
                                        questionIds.HaveYouEverHadMoreThanTwoConsecutiveWeeksOffSickDueToDiabetesInTheLastTwoYears,
                                    )}
                                />
                                <MultiButtonQuestion
                                    readonly={props.readonly}
                                    mandatory
                                    questionConfig={getQuestionConfig(
                                        props.questionConfigs,
                                        questionIds.AreYourDiabetesSymptomsWellControlled,
                                    )}
                                />
                                <MultiButtonQuestion
                                    readonly={props.readonly}
                                    mandatory
                                    questionConfig={getQuestionConfig(
                                        props.questionConfigs,
                                        questionIds.DoYouRequireAnyAdaptationsInTheWorkplaceToAccommodateYourDiabetes,
                                    )}
                                />
                                <MultiButtonQuestion
                                    readonly={props.readonly}
                                    mandatory
                                    questionConfig={getQuestionConfig(
                                        props.questionConfigs,
                                        questionIds.HaveYouHadAHypoGlycaemicEpisodeInTheLast12Months,
                                    )}
                                />
                            </>
                }
            </>
        );
    const stomachOrBowelProblemsQuestions = () =>
        (
            <>
                {<MultiButtonQuestion
                    readonly={props.readonly}
                    questionClassName="question-bold"
                    mandatory
                    questionConfig={getQuestionConfig(
                        props.questionConfigs,
                        questionIds.StomachOrBowelProblems,
                    )}
                />}
                {
                    showQuestionsIfAnsweredYes(questionIds.StomachOrBowelProblems) &&
                            <>
                                <MultiButtonQuestion
                                    readonly={props.readonly}
                                    mandatory
                                    questionConfig={getQuestionConfig(
                                        props.questionConfigs,
                                        questionIds.HaveYouBeenAdmittedToHospitalDueToStomachOrBowelProblemsInTheLastTwoYears,
                                    )}
                                />
                                <MultiButtonQuestion
                                    readonly={props.readonly}
                                    mandatory
                                    questionConfig={getQuestionConfig(
                                        props.questionConfigs,
                                        questionIds.HaveYouEverHadMoreThanTwoConsecutiveWeeksOffSickDueToStomachOrBowelProblems,
                                    )}
                                />
                                <MultiButtonQuestion
                                    readonly={props.readonly}
                                    mandatory
                                    questionConfig={getQuestionConfig(
                                        props.questionConfigs,
                                        questionIds.AreYourStomachOrBowelSymptomsWellControlled,
                                    )}
                                />
                                <MultiButtonQuestion
                                    readonly={props.readonly}
                                    mandatory
                                    questionConfig={getQuestionConfig(
                                        props.questionConfigs,
                                        questionIds.DoYouRequireAnyAdaptationsInTheWorkplaceToAccommodateAnyStomachOrBowelProblems,
                                    )}
                                />
                            </>
                }
            </>
        );
    const dyslexiaDyspraxiaAutismADHDOrOtherNeurodivergentConditionQuestions = () =>
        (
            <>
                {<MultiButtonQuestion
                    readonly={props.readonly}
                    questionClassName="question-bold"
                    mandatory
                    questionConfig={getQuestionConfig(
                        props.questionConfigs,
                        questionIds.DyslexiaDyspraxiaAutismADHDOrOtherNeurodivergentCondition,
                    )}
                />}
                {
                    showQuestionsIfAnsweredYes(questionIds.DyslexiaDyspraxiaAutismADHDOrOtherNeurodivergentCondition) &&
                            <>
                                <MultiButtonQuestion
                                    readonly={props.readonly}
                                    mandatory
                                    questionConfig={getQuestionConfig(
                                        props.questionConfigs,
                                        questionIds.DoYouHaveDyslexiaOrDyspraxia,
                                    )}
                                />
                                <MultiButtonQuestion
                                    readonly={props.readonly}
                                    mandatory
                                    questionConfig={getQuestionConfig(
                                        props.questionConfigs,
                                        questionIds.DoYouHaveAnAutisticSpectrumOrOtherNeurodiverseCondition,
                                    )}
                                />
                                <MultiButtonQuestion
                                    readonly={props.readonly}
                                    mandatory
                                    questionConfig={getQuestionConfig(
                                        props.questionConfigs,
                                        questionIds.DoYouRequireAnyAdaptationsInTheWorkplaceToAccommodateYourNeurodiverseCondition,
                                    )}
                                />
                            </>
                }
            </>
        );
    const otherHealthProblemsNotCoveredAboveQuestions = () =>
        (
            <>
                {<MultiButtonQuestion
                    readonly={props.readonly}
                    questionClassName="question-bold"
                    mandatory
                    questionConfig={getQuestionConfig(
                        props.questionConfigs,
                        questionIds.OtherHealthProblemsNotCoveredAbove,
                    )}
                />}
                {
                    showQuestionsIfAnsweredYes(questionIds.OtherHealthProblemsNotCoveredAbove) &&
                            <>
                                <MultiButtonQuestion
                                    readonly={props.readonly}
                                    mandatory
                                    questionConfig={getQuestionConfig(
                                        props.questionConfigs,
                                        questionIds.HaveYouBeenAdmittedToHospitalDueToAnyOtherUnspecifiedHealthProblemInTheLastTwoYears,
                                    )}
                                />
                                <MultiButtonQuestion
                                    readonly={props.readonly}
                                    mandatory
                                    questionConfig={getQuestionConfig(
                                        props.questionConfigs,
                                        questionIds.HaveYouHadMoreThanTwoConsecutiveWeeksOffSickDueToAnyOtherUnspecifiedHealthProblemInTheLastTwoYears,
                                    )}
                                />
                                <MultiButtonQuestion
                                    readonly={props.readonly}
                                    mandatory
                                    questionConfig={getQuestionConfig(
                                        props.questionConfigs,
                                        questionIds.IfYouAreOnMedicationAreYourOtherHealthSymptomsWellControlled,
                                    )}
                                />
                                <MultiButtonQuestion
                                    readonly={props.readonly}
                                    mandatory
                                    questionConfig={getQuestionConfig(
                                        props.questionConfigs,
                                        questionIds.DoYouRequireAnyAdaptationsInTheWorkplaceToAccommodateDueToAnyOtherUnspecifiedHealthProblem,
                                    )}
                                />
                            </>
                }
            </>
        );

    return (
        <ContextAwareProgressBarQuestionnaireSection
            {...props}
            {...sections.NightWorker}
        >
            <h4>Do you have or have you ever experienced a health problem or disability associated with the following?</h4>
            {anxietyStressOrDepressionQuestions()}
            {otherMentalHealthProblemsIncludingAnyDrugOrAlcoholProblemsQuestions()}
            {heartConditionAnginaHighBloodPressureQuestions()}
            {asthmaBronchitisChestDiseaseRespiratoryProblemsQuestions()}
            {fitsBlackoutsFaintsUnexplainedLossOfConsciousnessQuestions()}
            {diabetesQuestions()}
            {stomachOrBowelProblemsQuestions()}
            {dyslexiaDyspraxiaAutismADHDOrOtherNeurodivergentConditionQuestions()}
            {otherHealthProblemsNotCoveredAboveQuestions()}
            {
                <>
                    <MultiButtonQuestion
                        readonly={props.readonly}
                        questionClassName="question-bold"
                        mandatory
                        questionConfig={getQuestionConfig(
                            props.questionConfigs,
                            questionIds.DoesYourHealthReduceYourAbilityToWorkSafelyAtNight,
                        )}
                    />
                    <MultiButtonQuestion
                        readonly={props.readonly}
                        questionClassName="question-bold"
                        mandatory
                        questionConfig={getQuestionConfig(
                            props.questionConfigs,
                            questionIds.AreYouPregnant,
                        )}
                    />
                </>
            }
        </ContextAwareProgressBarQuestionnaireSection>
    );
};

// eslint-disable-next-line max-len
export const HealthSurveillanceNightWorkerSection = connect(makeMapStateToQuestionnaireSectionProps(sections.NightWorker.id), mapDispatchToQuestionnaireSectionProps)(HealthSurveillanceNightWorkerSectionUnconnected);

